var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 161,
    viewBox: "0 0 234 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85.6729,
    y: 73.4561,
    width: 12.4981,
    height: 17.7057,
    fill: "white",
    stroke: "#73DC78",
    strokeWidth: 1.38867,
    strokeDasharray: "2.6 2.17"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 104.739,
    y: 56.124,
    width: 12.4981,
    height: 35.0642,
    fill: "white",
    stroke: "#73DC78",
    strokeWidth: 1.38867,
    strokeDasharray: "2.6 2.17"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 123.897,
    y: 63.0322,
    width: 12.4981,
    height: 28.1208,
    fill: "white",
    stroke: "#73DC78",
    strokeWidth: 1.38867,
    strokeDasharray: "2.6 2.17"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 142.967,
    y: 37.0107,
    width: 12.4981,
    height: 54.1585,
    fill: "white",
    stroke: "#73DC78",
    strokeWidth: 1.38867,
    strokeDasharray: "2.6 2.17"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.972 93.6133H77.1797",
    stroke: "#00004B",
    strokeWidth: 1.47546
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.909 100.291L126.814 100.189C127.009 99.7672 127.07 99.2959 126.988 98.8385C126.907 98.3812 126.687 97.9597 126.359 97.6309C126.045 97.3169 125.646 97.1018 125.21 97.0122C124.775 96.9225 124.323 96.9623 123.911 97.1266L123.401 96.6844C127.081 91.4297 129.051 85.1683 129.041 78.754C129.041 61.4577 115.017 47.4375 97.7163 47.4375C80.4155 47.4375 66.3877 61.454 66.3877 78.7504C66.3877 96.0467 80.4137 110.067 97.7145 110.067C104.532 110.077 111.165 107.854 116.597 103.737L116.975 104.074C116.818 104.483 116.783 104.929 116.874 105.358C116.966 105.787 117.179 106.181 117.489 106.491C117.804 106.803 118.202 107.018 118.636 107.108C119.07 107.198 119.521 107.16 119.934 106.999C119.98 107.039 120.024 107.082 120.064 107.129L144.34 131.389L151.182 124.551L126.909 100.291Z",
    fill: "#DFE2E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.654 100.729C122.228 100.303 121.989 99.7248 121.989 99.1222C121.989 98.5196 122.228 97.9417 122.654 97.5152L128.306 91.8655C128.517 91.6543 128.768 91.4867 129.044 91.3724C129.32 91.2581 129.616 91.1992 129.914 91.1992C130.213 91.1992 130.509 91.2581 130.785 91.3724C131.061 91.4867 131.311 91.6543 131.522 91.8655C131.948 92.292 132.188 92.8699 132.188 93.4725C132.188 94.0751 131.948 94.653 131.522 95.0795L125.871 100.729C125.66 100.94 125.409 101.108 125.133 101.222C124.857 101.337 124.561 101.396 124.263 101.396C123.964 101.396 123.668 101.337 123.392 101.222C123.116 101.108 122.866 100.94 122.654 100.729Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.914 91.9305C129.712 91.9305 129.511 91.9704 129.324 92.048C129.137 92.1255 128.967 92.2391 128.824 92.3824L123.172 98.0319L123.172 98.0322C122.883 98.3216 122.721 98.7138 122.721 99.1227C122.721 99.5316 122.883 99.9238 123.172 100.213M128.764 90.6976C129.128 90.5465 129.519 90.4688 129.914 90.4688C130.309 90.4688 130.7 90.5465 131.065 90.6976C131.429 90.8488 131.761 91.0702 132.04 91.3494L132.04 91.3496C132.603 91.9131 132.919 92.6767 132.919 93.4729C132.919 94.2691 132.603 95.0328 132.04 95.5963L126.388 101.246L126.388 101.246C126.109 101.525 125.778 101.747 125.413 101.898C125.048 102.049 124.657 102.127 124.263 102.127C123.868 102.127 123.477 102.049 123.112 101.898C122.747 101.747 122.416 101.525 122.137 101.246L122.654 100.73L122.137 101.246C121.574 100.682 121.258 99.9188 121.258 99.1227C121.258 98.3265 121.574 97.5628 122.137 96.9993L127.789 91.3494L127.789 91.3492C128.068 91.0701 128.399 90.8487 128.764 90.6976ZM123.172 100.213C123.315 100.357 123.485 100.47 123.672 100.548C123.859 100.625 124.06 100.665 124.263 100.665C124.465 100.665 124.666 100.625 124.853 100.548C125.04 100.47 125.21 100.356 125.353 100.213L131.005 94.5636L131.005 94.5633C131.294 94.2739 131.456 93.8818 131.456 93.4729C131.456 93.064 131.294 92.6718 131.005 92.3824",
    fill: "#00004B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.878 104.305C120.179 104.305 134.204 90.284 134.204 72.9884C134.204 55.6928 120.179 41.6719 102.878 41.6719C85.5763 41.6719 71.5508 55.6928 71.5508 72.9884C71.5508 90.284 85.5763 104.305 102.878 104.305Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.878 42.4032C85.9813 42.4032 72.2831 56.0966 72.2831 72.9888C72.2831 89.881 85.9813 103.574 102.878 103.574C119.776 103.574 133.474 89.881 133.474 72.9888C133.474 56.0966 119.776 42.4032 102.878 42.4032ZM70.8203 72.9888C70.8203 55.2898 85.173 40.9414 102.878 40.9414C120.584 40.9414 134.937 55.2898 134.937 72.9888C134.937 90.6879 120.584 105.036 102.878 105.036C85.173 105.036 70.8203 90.6879 70.8203 72.9888Z",
    fill: "#00004B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.878 47.1328C107.998 47.1292 113.003 48.6431 117.262 51.483C121.52 54.3229 124.84 58.3612 126.802 63.0871C128.763 67.8129 129.278 73.0139 128.281 78.0321C127.284 83.0503 124.82 87.6602 121.2 91.2787C117.581 94.8971 112.969 97.3615 107.948 98.36C102.926 99.3586 97.7217 98.8465 92.9918 96.8884C88.262 94.9304 84.2195 91.6144 81.3759 87.36C78.5322 83.1056 77.0152 78.104 77.0166 72.9878C77.0159 69.5932 77.6842 66.2317 78.9835 63.0952C80.2828 59.9587 82.1875 57.1087 84.589 54.7078C86.9905 52.307 89.8416 50.4023 92.9797 49.1026C96.1178 47.8029 99.4813 47.1335 102.878 47.1328Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.678 50.8247C109.727 48.1935 104.039 47.2924 98.5163 48.2646C92.9941 49.2369 87.9559 52.0267 84.2032 56.1903C80.4505 60.3538 78.1989 65.6519 77.8066 71.2416C77.4143 76.8313 78.9039 82.3916 82.0383 87.0378L81.4319 87.4464L82.0391 87.039C84.3336 90.4546 87.4354 93.2521 91.07 95.1838C94.7045 97.1155 98.7597 98.1218 102.876 98.1136H102.878C108.485 98.1135 113.931 96.2394 118.35 92.7896C122.768 89.3398 125.906 84.5124 127.262 79.0755C128.619 73.6385 128.117 67.9043 125.837 62.7851C123.557 57.666 119.629 53.4559 114.678 50.8247ZM80.8249 87.8542C77.5084 82.9377 75.9323 77.0541 76.3474 71.1393C76.7625 65.2243 79.1452 59.6178 83.1163 55.212C87.0874 50.8061 92.4189 47.8539 98.2625 46.825C104.106 45.7962 110.126 46.7498 115.365 49.5341C120.604 52.3184 124.76 56.7735 127.173 62.1907C129.586 67.6078 130.117 73.6758 128.682 79.4292C127.246 85.1826 123.926 90.2909 119.25 93.9415C114.575 97.5918 108.812 99.5749 102.879 99.5754C98.5221 99.5841 94.23 98.519 90.3831 96.4744C86.5364 94.4299 83.2534 91.4692 80.8249 87.8542Z",
    fill: "#00004B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.23 101.367L149.504 125.625L156.347 118.786L132.073 94.5284L125.23 101.367Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.504 126.658L124.195 101.367L132.073 93.4943L157.382 118.786L149.504 126.658ZM149.504 124.591L155.313 118.786L132.073 95.5616L126.264 101.367L149.504 124.591Z",
    fill: "#00004B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9748_12697)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.3809,
    y: 73.6924,
    width: 12.4981,
    height: 17.7057,
    fill: "white",
    stroke: "#73DC78",
    strokeWidth: 1.38867
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.452,
    y: 56.3584,
    width: 12.4981,
    height: 35.0642,
    fill: "white",
    stroke: "#73DC78",
    strokeWidth: 1.38867
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.604,
    y: 63.2666,
    width: 12.4981,
    height: 28.1208,
    fill: "white",
    stroke: "#73DC78",
    strokeWidth: 1.38867
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.684 93.8477H76.8916",
    stroke: "#00004B",
    strokeWidth: 1.47546
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.639 51.1079C109.688 48.4767 103.999 47.5756 98.4772 48.5478C92.955 49.5201 87.9168 52.3099 84.1641 56.4735C80.4114 60.637 78.1598 65.9351 77.7675 71.5248C77.3752 77.1146 78.8648 82.6749 81.9992 87.3211L81.3928 87.7296L82 87.3223C84.2945 90.7379 87.3964 93.5354 91.0309 95.4671C94.6655 97.3988 98.7206 98.4051 102.837 98.3969H102.839C108.446 98.3967 113.892 96.5227 118.311 93.0729C122.729 89.6231 125.866 84.7957 127.223 79.3587C128.58 73.9217 128.078 68.1875 125.798 63.0683C123.518 57.9492 119.59 53.7391 114.639 51.1079ZM80.7859 88.1375C77.4693 83.221 75.8933 77.3374 76.3084 71.4226C76.7235 65.5075 79.1061 59.901 83.0772 55.4952C87.0484 51.0893 92.3798 48.1371 98.2234 47.1082C104.067 46.0794 110.087 47.033 115.326 49.8173C120.565 52.6016 124.721 57.0568 127.134 62.4739C129.547 67.891 130.078 73.959 128.642 79.7124C127.207 85.4658 123.887 90.5742 119.211 94.2248C114.536 97.8751 108.773 99.8582 102.84 99.8587C98.483 99.8673 94.191 98.8022 90.3441 96.7577C86.4973 94.7132 83.2144 91.7524 80.7859 88.1375Z",
    fill: "#00004B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9748_12697"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.2793,
    y: 46.6836,
    width: 53.1896,
    height: 53.1536,
    rx: 26.5768,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductSearchIcon);
export default __webpack_public_path__ + "static/media/product-search-icon.043af4fc545b60b91d0baeadd9fc67be.svg";
export { ForwardRef as ReactComponent };